import {environment} from "../../environments/environment";
import {EventEmitter, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {CookieService} from "ngx-cookie-service";
import {Observable} from "rxjs";
import {ContentResponse} from "../interface/contentResponse";
import {ContentRequest} from "../interface/contentRequest";
import {DashboardDataDto} from "../interface/dashboardDataDto";
import {ContentUpdateRequest} from "../interface/contentUpdateRequest";

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  private apiUrl = environment.apiUrl;
  private contentUpdateEmitter: EventEmitter<string | null> = new EventEmitter<string | null>();

  constructor(private http: HttpClient,
              private cookieService: CookieService) {

  }

  get token() {
    const token = this.cookieService.get('Token');
    return token;
  }

  get updatedContent(): EventEmitter<string | null> {
    return this.contentUpdateEmitter;
  }

  set updatedContent(value: EventEmitter<string | null>) {
    this.contentUpdateEmitter = value;
  }

  getAllContent(): Observable<ContentResponse[]> {
    return this.http.get<ContentResponse[]>(`${this.apiUrl}/admin/content/`);
  }

  getContentById(id: bigint): Observable<ContentResponse> {
    return this.http.get<ContentResponse>(`${this.apiUrl}/admin/content/${id}`);
  }

  createContent(request: ContentRequest): Observable<ContentResponse>{
    return this.http.post<ContentResponse>(`${this.apiUrl}/admin/content/`, request);
  }

  uploadContentIcon(id: bigint, icon: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('contentIcon', icon as Blob, icon?.name);
    return this.http.post(`${this.apiUrl}/admin/content/upload/${id}`, formData);
  }

  updateContent(id: bigint, content: ContentUpdateRequest): Observable<ContentResponse> {
    return this.http.put<ContentResponse>(`${this.apiUrl}/admin/content/${id}`, content);
  }

  getImage(image: string) {
    return `${this.apiUrl}/admin/content/getImage?image=${image}`;
  }

  deleteContentById(id: bigint){
    return this.http.delete<string>(`${this.apiUrl}/admin/content/${id}`, {responseType: 'text' as 'json'  });
  }

  getDashboardData(): Observable<DashboardDataDto> {
    const endpoint = `${this.apiUrl}/admin/content/dashboard-data`;
    return this.http.get<DashboardDataDto>(endpoint);
  }
}
